import { api_GET } from "services/api_service";

export const getSetupAmibiente = (callback) => {
    api_GET('SetupGeral').then(result => {
        callback(result);
    });
}